import type { RouteParamsGeneric } from 'vue-router'

const DEFAULT_LCID = 'en'

export const getLcidFromRouteParams = (routeParams: RouteParamsGeneric) => {
  if (typeof routeParams !== undefined && typeof routeParams.lcid !== 'undefined') {
    if (Array.isArray(routeParams.lcid) && routeParams.lcid.length > 0) {
      return `${routeParams.lcid[0] || DEFAULT_LCID}`
    } else if (typeof routeParams.lcid === 'string') {
      return routeParams.lcid || DEFAULT_LCID
    }
  }
  return DEFAULT_LCID
}
